export type WithdrawalRequestStep = 'submitted' | 'awaitingContractsSigned' | 'creditAssessmentComplete' | 'awaitingPayout';

export const WithdrawalRequestStep = {
    Submitted: 'submitted' as WithdrawalRequestStep,
    AwaitingContractsSigned: 'awaitingContractsSigned' as WithdrawalRequestStep,
    CreditAssessmentComplete: 'creditAssessmentComplete' as WithdrawalRequestStep,
    AwaitingPayout: 'awaitingPayout' as WithdrawalRequestStep,
};